export default __webpack_public_path__ + "static/media/mini-secured-card.d017e8bc.png";